import { Rating } from '@material-ui/lab';
import { CustomViewRegister } from '../CustomView/registry';
import { GenericField } from '../DisplayValue';
import { CustomViewGridElement } from './utility';

CustomViewRegister.register({
  id: 'stars',
  function: function Stars({
    value,
    mode,
    label,
    maxValue = 5,
    colSpan,
  }: {
    value: any;
    maxValue?: number;
    mode?: string;
    label?: string;
    colSpan?: number;
  }) {
    let content;

    if (value !== undefined) {
      // maxValue is clamped to 0 to avoid division by zero
      const scale = Math.max(1, maxValue);
      const normalizedValue = value / (scale / 5);
      content = <Rating value={normalizedValue} readOnly />;
    }

    if (mode === 'table') {
      return <GenericField value={content} />;
    }

    return (
      <CustomViewGridElement colSpan={colSpan}>
        <GenericField label={label} value={content} />
      </CustomViewGridElement>
    );
  },
});
